import { render, staticRenderFns } from "./AddFacebookForm.vue?vue&type=template&id=75737429&scoped=true&"
import script from "./AddFacebookForm.vue?vue&type=script&lang=js&"
export * from "./AddFacebookForm.vue?vue&type=script&lang=js&"
import style0 from "./AddFacebookForm.vue?vue&type=style&index=0&id=75737429&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75737429",
  null
  
)

export default component.exports